import type { IconSvgObject } from './types';

const TransactionHistoryIcon: IconSvgObject = [
  ["path", { d: "M10.5 22H5C3.89542 22 2.99999 21.1046 3 20L3.00014 3.99998C3.00015 2.89542 3.89558 2 5.00014 2H17C18.1046 2 19 2.89543 19 4V10.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7 7H15M7 11H11", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M18 18.5L16.5 17.95V15.5M12 17.5C12 19.9853 14.0147 22 16.5 22C18.9853 22 21 19.9853 21 17.5C21 15.0147 18.9853 13 16.5 13C14.0147 13 12 15.0147 12 17.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default TransactionHistoryIcon;
